import {useEffect, useState} from 'react'
import * as http from '../../../../api/http'

export interface OpcionCatalogo {
  codigo: string
  valor: string
  codigo_nombre: string
}

export interface CatalogoOpcional {
  opciones: Array<OpcionCatalogo>
  cargando: boolean
  disponible: boolean
}

const normalizar = (filas: any): Array<OpcionCatalogo> => {
  if (!Array.isArray(filas)) return []
  return filas
    .filter((fila: any) => fila && (fila.activo === undefined || `${fila.activo}` !== 'false'))
    .map((fila: any) => {
      const codigo = `${fila?.codigo ?? ''}`.trim()
      const valor = `${fila?.valor ?? ''}`.trim()
      return {codigo, valor, codigo_nombre: valor ? `${codigo} - ${valor}` : codigo}
    })
    .filter((opcion: OpcionCatalogo) => opcion.codigo !== '')
}

export default function useCatalogoOpcional(endpoint: string, habilitado: boolean = true) {
  const [catalogo, setCatalogo] = useState<CatalogoOpcional>({
    opciones: [],
    cargando: false,
    disponible: false,
  })

  useEffect(() => {
    let vigente = true

    if (!habilitado || !endpoint) {
      setCatalogo({opciones: [], cargando: false, disponible: false})
      return () => {
        vigente = false
      }
    }

    setCatalogo({opciones: [], cargando: true, disponible: false})

    http
      .get(endpoint)
      .then((respuesta: any) => {
        if (!vigente) return
        const opciones = normalizar(respuesta?.body ?? respuesta?.data)
        setCatalogo({opciones, cargando: false, disponible: opciones.length > 0})
      })
      .catch(() => {
        if (!vigente) return
        setCatalogo({opciones: [], cargando: false, disponible: false})
      })

    return () => {
      vigente = false
    }
  }, [endpoint, habilitado])

  return catalogo
}
